import React, { Component } from 'react';
import './Login.css';

export default class Login extends Component {

	handleSubmit = (e) => {
		e.preventDefault();
		this.props.signIn(this.email.value, this.password.value);
	}

	render() {
		return(
				<form action="" onSubmit={this.handleSubmit} name="login">
					<label>Your email address</label>
          <input type="email" 
                 ref={ (input) => this.email = input }
          />

          <label>Your password</label>
          <input type="password" 
                 ref={ (input) => this.password = input }
          />
          <button type="submit" className="btn btn-primary btn-wd btn-lg">Login</button>
				</form>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Login.js